import React from 'react';

export default function Question() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13V14.5L9.0625 12.2188C9.21875 12.0938 9.4375 12 9.65625 12H14C14.5312 12 15 11.5625 15 11V2C15 1.46875 14.5312 1 14 1H2C1.4375 1 1 1.46875 1 2V11C1 11.5625 1.4375 12 2 12H5C5.53125 12 6 12.4688 6 13ZM2 0H14C15.0938 0 16 0.90625 16 2V11C16 12.125 15.0938 13 14 13H9.65625L5.78125 15.9062C5.625 16.0312 5.4375 16.0312 5.25 15.9688C5.09375 15.875 5 15.7188 5 15.5V14V13H4H2C0.875 13 0 12.125 0 11V2C0 0.90625 0.875 0 2 0ZM5.25 3.8125C5.46875 3.0625 6.15625 2.5 6.9375 2.5H8.75C9.84375 2.5 10.75 3.40625 10.75 4.53125C10.75 5.28125 10.3125 5.96875 9.65625 6.3125L8.5 6.90625V7.5C8.5 7.78125 8.25 8 8 8C7.71875 8 7.5 7.78125 7.5 7.5V6.59375C7.5 6.40625 7.59375 6.25 7.75 6.15625L9.1875 5.40625C9.53125 5.25 9.75 4.90625 9.75 4.53125C9.75 3.96875 9.28125 3.5 8.75 3.5H6.9375C6.59375 3.5 6.3125 3.75 6.21875 4.0625V4.09375C6.15625 4.375 5.875 4.53125 5.59375 4.4375C5.34375 4.375 5.1875 4.09375 5.25 3.84375V3.8125ZM8.75 9.5C8.75 9.9375 8.40625 10.25 8 10.25C7.5625 10.25 7.25 9.9375 7.25 9.5C7.25 9.09375 7.5625 8.75 8 8.75C8.40625 8.75 8.75 9.09375 8.75 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
